import {
    ODataHeader,
    ODataString,
    ODataBoolean,
    ODataDate
} from "pbas-vue-components";
import { translate } from '../trans'
import store from '@/store'

const NotificationsHeaders = [
    new ODataHeader({
        title: "Id",
        type: new ODataString("Id"),
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        title: "PlanId",
        type: new ODataString("PlanId"),
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Name"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    // new ODataHeader({
    //     type: new ODataString("Type/Name"),
    //     visible: false,
    //     allowVisibilityChange: false,
    // }),
    // new ODataHeader({
    //     type: new ODataString("Type/Translations[]/LanguageCode"),
    //     visible: false,
    //     allowVisibilityChange: false
    // }),
    // new ODataHeader({
    //     title: "headers.notifications.type",
    //     type: new ODataString("Type/Translations[]/DisplayValue", {
    //         getString: item => {
    //             if (!item) return "";
    //             const lang = store.getters['common/language']
    //             return translate(item.Type, lang.language);
    //         }
    //     }),
    //     sortable: true,
    //     visible: true,
    //     searchable: true,
    //     orderByKey: "Type/Name"
    // }),
    new ODataHeader({
        title: "globals.active",
        type: new ODataBoolean("Active"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    // new ODataHeader({
    //     title: "headers.notifications.display_period_for",
    //     type: new ODataString("DisplayPeriod"),
    //     sortable: true,
    //     visible: true,
    //     searchable: true
    // }),
    new ODataHeader({
        type: new ODataString("Translations[]/Id"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("Translations[]/LanguageCode"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("Translations[]/Html"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version: 1
    }),
    new ODataHeader({
        type: new ODataString("PopupBehaviourId"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("PopupBehaviour/Id"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("PopupBehaviour/Name"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("PopupBehaviour/Translations[]/Id"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("PopupBehaviour/Translations[]/LanguageCode"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("PopupBehaviour/Translations[]/DisplayValue"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version: 1
    }),
    new ODataHeader({
        type: new ODataString("PopupPeriod"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("PopupPeriod/Id"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("PopupPeriod/Name"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("PopupPeriod/Translations[]/Id"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("PopupPeriod/Translations[]/LanguageCode"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("PopupPeriod/Translations[]/DisplayValue"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version: 1
    }),
    new ODataHeader({
        type: new ODataDate("From"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version: 1
    }),
    new ODataHeader({
        type: new ODataDate("To"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version: 1
    }),
];
export default NotificationsHeaders;